import type { StockActionRuntimePayload } from "../gateway/stock-action-client";
import { posRuntimeDb } from "./pos-db";
import type { TrustedTerminalIdentity } from "./terminal-state";

const DOMAIN = "STOCK_ACTION";

function scopeKey(identity: TrustedTerminalIdentity) {
  return `org:${identity.organization_id}:branch:${identity.branch_id}:node:${identity.node_id}`;
}

function projectionKey(identity: TrustedTerminalIdentity) {
  return `${scopeKey(identity)}:${DOMAIN}`;
}

export async function applyStockActionRuntime(
  identity: TrustedTerminalIdentity,
  payload: StockActionRuntimePayload,
) {
  if (payload.organization_id !== identity.organization_id || payload.branch_id !== identity.branch_id) {
    throw new Error("STOCK_ACTION_RUNTIME_SCOPE_MISMATCH");
  }
  await posRuntimeDb.projections.put({
    key: projectionKey(identity),
    scopeKey: scopeKey(identity),
    domain: DOMAIN,
    revision: payload.server_at,
    payload,
    updatedAt: new Date().toISOString(),
  });
}

export async function readStockActionRuntime(identity: TrustedTerminalIdentity) {
  const record = await posRuntimeDb.projections.get(projectionKey(identity));
  if (!record || record.domain !== DOMAIN || !record.payload || typeof record.payload !== "object") return null;
  return record.payload as StockActionRuntimePayload;
}

export async function purgeStockActionRuntimeOutsideScope(identity: TrustedTerminalIdentity) {
  const expected = scopeKey(identity);
  const stale = await posRuntimeDb.projections
    .where("domain")
    .equals(DOMAIN)
    .filter((row) => row.scopeKey !== expected)
    .primaryKeys();
  if (stale.length) await posRuntimeDb.projections.bulkDelete(stale);
}
